'use strict';
var parent = require('../../actual/object/keys');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/object/keys.js
// module id = 637
// module chunks = 13